import React, { useState } from 'react';
import './navbar.css';
import linkedinIcon from '../../assets/linkedin.png';
import githubIcon from '../../assets/github.png';
import emailIcon from '../../assets/email.png';
import { Link } from 'react-scroll';

const Navbar = () => {
    const [showMenu, setShowMenu] = useState(false);

    const toggleMenu = () => setShowMenu(!showMenu);

    return (
        <nav className="navbar">
            <div className="LeftName">
                Nick David
            </div>

            <div className="desktopMenu">
                <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="desktopMenuListItem">Home</Link>
                <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-50} duration={500} className="desktopMenuListItem">About Me</Link>
                <Link activeClass='active' to='works' spy={true} smooth={true} offset={-50} duration={500} className="desktopMenuListItem">Projects</Link>
                <Link activeClass='active' to='experience' spy={true} smooth={true} offset={-50} duration={500} className="desktopMenuListItem">Experience</Link>
            </div>

            <button className="desktopMenuBtn">
                <div className="contact">Contact Me</div>
                <div className="socialIcons">
                    <a href="https://www.linkedin.com/in/nicholasedavid/" target="_blank" rel="noopener noreferrer">
                        <img src={linkedinIcon} alt="LinkedIn" className="socialIcon" />
                    </a>
                    <a href="https://github.com/Nick-David1" target="_blank" rel="noopener noreferrer">
                        <img src={githubIcon} alt="GitHub" className="socialIcon" />
                    </a>
                    <a href="mailto:nicholas.e.david@gmail.com" target="_blank" rel="noopener noreferrer">
                        <img src={emailIcon} alt="Email" className="socialIcon" />
                    </a>
                </div>
            </button>

            <button className="mobMenu" onClick={toggleMenu}>
                <i className="fas fa-bars"></i>
            </button>
            <div className="navMenu" style={{ display: showMenu ? 'flex' : 'none' }}>
                <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className="listItem" onClick={toggleMenu}>Home</Link>
                <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={toggleMenu}>About Me</Link>
                <Link activeClass='active' to='works' spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={toggleMenu}>Projects</Link>
                <Link activeClass='active' to='experience' spy={true} smooth={true} offset={-50} duration={500} className="listItem" onClick={toggleMenu}>Experience</Link>
            </div>
        </nav>
    );
};

export default Navbar;
